import { LayoutGrid } from 'lucide-react';
import { AdminShell } from '@/apps/coach/components/admin/AdminShell';
import { TOOLS, type ToolKey } from '@/lib/tools';

const TOOL_ORDER: ToolKey[] = [
  'inner-team',
  'inner-strengths',
  'inner-values',
  'inner-purpose',
  'inner-journal',
];

export function Apps() {
  return (
    <AdminShell pageTitle="Apps">
      <div className="mx-auto max-w-5xl px-4 py-12 md:px-8 md:py-16">
        <div className="mb-8 flex items-center gap-3">
          <LayoutGrid size={20} className="text-primary" />
          <h1 className="text-2xl font-semibold">Apps für dich</h1>
        </div>
        <p className="mb-8 max-w-2xl text-sm text-muted-foreground">
          Hier kannst du die Plattform-Tools selbst nutzen — separat von deiner Coach-Tätigkeit.
          Jeder Klick öffnet das Tool in einem neuen Tab.
        </p>

        <div className="grid gap-4 sm:grid-cols-2">
          {TOOL_ORDER.map((key) => {
            const tool = TOOLS[key];
            const isActive = tool.status === 'active';
            const href = `https://app.teamity.io${tool.entryPath}`;

            const inner = (
              <>
                <h3 className="text-base font-semibold">
                  {tool.name}
                  {!isActive && (
                    <span className="ml-2 inline-flex items-center rounded-full bg-secondary-tint px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-secondary">
                      kommt bald
                    </span>
                  )}
                </h3>
                <p className="mt-1 text-sm text-muted-foreground">{tool.description}</p>
              </>
            );

            return isActive ? (
              <a
                key={key}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-2xl border border-border bg-card p-6 transition-colors hover:border-primary"
              >
                {inner}
              </a>
            ) : (
              <div
                key={key}
                className="rounded-2xl border border-border bg-card p-6 opacity-60"
              >
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </AdminShell>
  );
}
